import { DataDisplayEvent } from "@mcleod/components";
import { AutogenLayoutCustomerQuickInfo } from "./autogen/AutogenLayoutCustomerQuickInfo";
import { StringUtil } from "@mcleod/core";

export class CustomerQuickInfo extends AutogenLayoutCustomerQuickInfo {
    textboxIdOnDataDisplay(event: DataDisplayEvent) {
        this.textboxPartnerValue.visible = event?.rowData?.getBoolean("partner_value_visible", false);
    }

    textboxEdiCustomerScacDataDisplay(event: DataDisplayEvent) {
        this.textboxScac.visible = event?.rowData?.getBoolean("edi_customer_scac_visible", false);
    }

    textboxEdiCustomerCarrierOnDataDisplay(event: DataDisplayEvent) {
        this.textboxEdiCustomerCarrier.visible = event?.rowData?.getBoolean("edi_customer_carrier_visible", false);
    }

    textboxBridgeIdOnDataDisplay(event: DataDisplayEvent) {
        const bridgeId = event?.rowData?.getString("bridge_id", null);
        this.labelBridgeIdDescription.visible = !StringUtil.isEmptyString(bridgeId);
        this.textboxBridgeCustomer.visible = !StringUtil.isEmptyString(bridgeId);
    }
}
